import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { setCredentials } from "../../features/auth/authSlice";

const MockupLayout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCredentials({ token: "mockup", uid: "mockup", roles: [] }));
  }, [dispatch]);

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default MockupLayout;
